import styled from 'styled-components';

export default styled.div`
  th.ant-table-cell {
    padding: 8px !important;
  }
  td.ant-table-cell {
    padding: 4px !important;
  }
`;
